const findLeaveStatus = (list, statusList, status) => {
  return list?.find((el) => {
    el?.code.includes(statusList?.find((el) => el?._id === status)?.code);
  });
};

export default findLeaveStatus;
